import React from 'react'

export const BaasIllustrationBuble = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 1765 2399"
            fill="none"
        >
            <path
                d="M882.5 1450.77C1283.14 1450.77 1607.92 1126 1607.92 725.385C1607.92 324.766 1283.14 0 882.5 0C481.862 0 157.08 324.766 157.08 725.385C157.08 1126 481.862 1450.77 882.5 1450.77Z"
                fill="#78FFF0"
            />
            <path
                d="M904.829 2046.42C904.829 2058.78 894.668 2068.94 882.062 2068.94C869.456 2068.94 859.294 2058.78 859.294 2046.42C859.294 2034.06 869.456 2023.66 882.062 2023.66C894.668 2023.66 904.829 2033.82 904.829 2046.42Z"
                fill="#78FFF0"
            />
            <path
                d="M838.308 1876.41C849.879 1876.41 859.26 1867.03 859.26 1855.46C859.26 1843.89 849.879 1834.51 838.308 1834.51C826.737 1834.51 817.356 1843.89 817.356 1855.46C817.356 1867.03 826.737 1876.41 838.308 1876.41Z"
                fill="#78FFF0"
            />
            <path
                d="M990.871 1849.17C998.354 1849.17 1004.42 1843.11 1004.42 1835.63C1004.42 1828.14 998.354 1822.08 990.871 1822.08C983.388 1822.08 977.322 1828.14 977.322 1835.63C977.322 1843.11 983.388 1849.17 990.871 1849.17Z"
                fill="#78FFF0"
            />
            <path
                d="M919.077 1940.17C939.519 1940.17 956.091 1923.6 956.091 1903.16C956.091 1882.72 939.519 1866.14 919.077 1866.14C898.634 1866.14 882.062 1882.72 882.062 1903.16C882.062 1923.6 898.634 1940.17 919.077 1940.17Z"
                fill="#78FFF0"
            />
            <path
                d="M964.088 2018.49C980.692 2018.49 994.153 2005.03 994.153 1988.43C994.153 1971.82 980.692 1958.36 964.088 1958.36C947.483 1958.36 934.022 1971.82 934.022 1988.43C934.022 2005.03 947.483 2018.49 964.088 2018.49Z"
                fill="#78FFF0"
            />
            <path
                d="M965.31 1768.55C1023.88 1768.55 1071.36 1721.07 1071.36 1662.51C1071.36 1603.94 1023.88 1556.46 965.31 1556.46C906.74 1556.46 859.26 1603.94 859.26 1662.51C859.26 1721.07 906.74 1768.55 965.31 1768.55Z"
                fill="#78FFF0"
            />
            <path
                d="M1416.54 1821.66C1552.08 1821.66 1661.96 1711.79 1661.96 1576.26C1661.96 1440.73 1552.08 1330.86 1416.54 1330.86C1281.01 1330.86 1171.13 1440.73 1171.13 1576.26C1171.13 1711.79 1281.01 1821.66 1416.54 1821.66Z"
                fill="#78FFF0"
            />
            <path
                d="M1143.47 1988.43C1186.21 1988.43 1220.86 1953.78 1220.86 1911.05C1220.86 1868.31 1186.21 1833.67 1143.47 1833.67C1100.74 1833.67 1066.09 1868.31 1066.09 1911.05C1066.09 1953.78 1100.74 1988.43 1143.47 1988.43Z"
                fill="#78FFF0"
            />
            <circle cx="515.25" cy="2068.66" r="320" fill="#232323" />
            <path
                d="M496.586 1910.26H566.068C595.125 1910.26 618.726 1933.86 618.726 1962.91V2174.4C618.726 2203.45 595.125 2227.05 566.068 2227.05H496.586V1910.28V1910.26Z"
                fill="#F4F9F8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M788.542 2071.75C788.629 2070.73 788.651 2069.72 788.651 2068.68C788.651 2037.63 762.062 2009.46 729.605 1989.02C697.127 1968.72 658.651 1956.14 634.877 1956.14V2181.22C658.651 2181.22 697.127 2168.66 729.605 2148.2C751.019 2134.82 769.878 2118 780.25 2099.18C772.412 2096.67 760.091 2091.5 764.379 2084.96C768.016 2079.37 779.708 2074.65 788.542 2071.75ZM700.462 2048.69C691.13 2048.69 683.573 2039.75 683.573 2028.71C683.573 2017.67 691.13 2008.71 700.462 2008.71C709.794 2008.71 717.199 2017.65 717.199 2028.71C717.199 2039.77 709.664 2048.69 700.462 2048.69Z"
                fill="#78FFF0"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M241.85 2145.97V1991.34C274.523 1991.34 347.468 2025.96 347.468 2068.66C347.468 2111.35 274.523 2145.97 241.85 2145.97Z"
                fill="#78FFF0"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M435.615 2204.43H358.252V1932.88H435.615C460.342 1932.88 480.391 1956.63 480.391 1985.95V2151.36C480.391 2180.68 460.342 2204.43 435.615 2204.43Z"
                fill="#F4F9F8"
            />
        </svg>
    )
}
